import { useEffect, useState } from "react";
import { CTA_MODE, appHref } from "@/config";
import { scrollToLeadForm } from "@/lib/scroll";

export const Header = () => {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        solid ? "border-line bg-surface/95 backdrop-blur-md" : "border-transparent bg-transparent"
      }`}
    >
      <div className="nb-shell flex h-[68px] items-center justify-between">
        <a href="/" data-testid="wordmark" className="font-head text-xl tracking-[1px] text-ink">
          Night<span className="text-brand">Bay</span>
        </a>
        {CTA_MODE === "app" ? (
          <a data-testid="header-cta" href={appHref("renter")} className="nb-btn-primary !min-h-[42px] !px-4 text-xs">
            Open the app
          </a>
        ) : (
          <button
            data-testid="header-cta"
            type="button"
            onClick={() => scrollToLeadForm()}
            className="nb-btn-primary !min-h-[42px] !px-4 text-xs"
          >
            Get early access
          </button>
        )}
      </div>
    </header>
  );
};
